import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';
import { AssetsPipe } from './assets';
import { NgswService } from './ngsw';
import { CfContextService } from './context';

@NgModule({
  imports: [RouterModule, HttpClientModule],
  declarations: [AssetsPipe],
  exports: [AssetsPipe],
  providers: [NgswService, CfContextService],
})
export class UtilsModule {}
